import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';
import { FilterPagination, ResultsInvoice } from '../../interface/company-client.interface';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { CdkContextMenuTrigger } from '@angular/cdk/menu';

@Component({
  selector: 'app-client-buy-invoices',
  templateUrl: './client-buy-invoices.component.html',
  styleUrls: ['./client-buy-invoices.component.scss']
})
export class ClientBuyInvoicesComponent implements OnInit, OnChanges{
  @Input() result: PageResult<ResultsInvoice>;
  @Output() changePagination = new EventEmitter<FilterPagination>;
  @Output() changeSortOrder = new EventEmitter<string>;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @Output() viewRelationWithClient = new EventEmitter<number>;
  public menu!: CdkContextMenuTrigger;


  public dataSource: MatTableDataSource<ResultsInvoice>;
  public displayCols = [
    'folio',
    'clientName',
    'clientRut',
    'totalAmount',
    'fechaDocto',
    'hasBuyOrder',
   // 'isCedible',
    'numberInvoice',
    'numberInvoiceInFactoring',
  ];

  constructor(){
    this.dataSource = new MatTableDataSource([]);
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['result']){
      const updatedResult: PageResult<ResultsInvoice> = changes['result'].currentValue;
      if(updatedResult)
        this.setDataSource(updatedResult);
    }
  }

  setDataSource(pagedResult: PageResult<ResultsInvoice>){
    this.dataSource.data = pagedResult.results ?? [];
    this.paginator.length = pagedResult.totalRows;
    this.paginator.pageIndex = pagedResult.currentPage -1 ;
    this.paginator.pageSize = pagedResult.pageSize;
    if(pagedResult.sortColumn && pagedResult.sortDirection) {
      this.sort.active = pagedResult.sortColumn.charAt(0).toLowerCase() + pagedResult.sortColumn.slice(1);
      this.sort.direction = pagedResult.sortDirection === 'asc' ? 'asc' : 'desc';
    } else {
      this.sort.active = '';
      this.sort.direction = '';
    }

  }

  changePaginationTable(event: PageEvent) {
    const pagination: FilterPagination = {
      page: event.pageIndex + 1,
      pageSize: event.pageSize
    };
    this.changePagination.emit(pagination);
  }

  sortOrderChange(sortState: Sort) {
    if(sortState.direction === '') {
      this.changeSortOrder.emit(null);
      return;
    }
    const sortCol = sortState.active.charAt(0).toUpperCase() + sortState.active.slice(1);
    const sortConf = `${sortCol}_${sortState.direction}`;
    this.changeSortOrder.emit(sortConf);  
  }

  viewDebtorRelation(fullRut: string) {
    const rut = fullRut.replace(/\./g,'').split('-')[0];
    this.viewRelationWithClient.emit(Number.parseInt(rut));
  }
}
